module.exports = __webpack_public_path__ + "img/automotive-explore.2d61a222.jpg";